/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainEntitiesDocumentsDocumentFromJSON, FxIdDomainEntitiesDocumentsDocumentToJSON, } from './FxIdDomainEntitiesDocumentsDocument';
/**
 * Check if a given object implements the FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponse interface.
 */
export function instanceOfFxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponse(value) {
    if (!('Documents' in value) || value['Documents'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseFromJSON(json) {
    return FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Documents': (json['Documents'].map(FxIdDomainEntitiesDocumentsDocumentFromJSON)),
    };
}
export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseToJSON(json) {
    return FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Documents': (value['Documents'].map(FxIdDomainEntitiesDocumentsDocumentToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsResponse.js.map